import { render, staticRenderFns } from "./ListBnRetrClientsRegl.vue?vue&type=template&id=3319ba92&scoped=true&"
import script from "./ListBnRetrClientsRegl.vue?vue&type=script&lang=js&"
export * from "./ListBnRetrClientsRegl.vue?vue&type=script&lang=js&"
import style0 from "./ListBnRetrClientsRegl.vue?vue&type=style&index=0&id=3319ba92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319ba92",
  null
  
)

export default component.exports